<template>
    <div class="Usermanagement">
        <div class="Usermanagementborder">
            <p>头像管理</p>
            <div class="el-form-item left margin-left2">
                <!-- <el-upload
                    action="#"
                    list-type="picture-card"
                    :auto-upload="false"
                    :on-change="onChange"
                >
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                        <span class="el-upload-list__item-actions">
                            <span
                                class="el-upload-list__item-preview"
                                @click="handlePictureCardPreview(file)"
                            >
                                <i class="el-icon-zoom-in"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img v-if="dialogImageUrl" width="100%" :src="dialogImageUrl" alt />
                </el-dialog>-->
                <el-upload
                    :action="action"
                    :on-success="handleAvatarSuccess"
                    :show-file-list="false"
                    list-type="picture-card"
                    :headers="customHeaders"
                >
                    <img
                        width="100%"
                        height="100%"
                        v-if="dialogImageUrl"
                        :src="dialogImageUrl"
                        class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </div>
            <!-- 保存头像 -->
            <div class="bbutton">
                <el-button type="primary" style="float:right;" @click="handleHead">保存</el-button>
            </div>
        </div>
        <div class="Usermanagementborder margin-left2">
            <p>常规信息</p>
            <div class="el-form-item left">
                <label class="el-form-item__label" for style="width: 80px;">姓名</label>
                <div class="el-form-item__content" style="margin-left: 80px;">
                    <el-input v-model="message.name" placeholder="请输入姓名" class="width40"></el-input>
                </div>
            </div>
            <div class="el-form-item left">
                <label class="el-form-item__label" for style="width: 80px;">性别</label>
                <div class="el-form-item__content" style="margin-left: 80px;">
                    <el-radio v-model="message.radio" label="1">男</el-radio>
                    <el-radio v-model="message.radio" label="2">女</el-radio>
                </div>
            </div>
            <div class="el-form-item left">
                <label class="el-form-item__label" for style="width: 80px;">生日</label>
                <div class="el-form-item__content" style="margin-left: 80px;">
                    <!-- <el-input v-model="message.birthday" placeholder="请输入生日" class="width40"></el-input> -->
                    <el-date-picker v-model="message.birthday" type="date" placeholder="请选择生日"></el-date-picker>
                </div>
            </div>
            <!-- <div class="el-form-item left">
                <label class="el-form-item__label" for style="width: 80px;">血型</label>
                <div class="el-form-item__content" style="margin-left: 80px;">
                    <el-input v-model="message.bloodType" placeholder="请输入血型" class="width40"></el-input>
                </div>
            </div>-->
            <div class="el-form-item left" style="width: 90%;">
                <label class="el-form-item__label" for style="width: 80px;">所在地</label>
                <div class="el-form-item__content" style="margin-left: 80px;">
                    <el-input v-model="message.location" placeholder="请输入所在地"></el-input>
                </div>
            </div>
            <!-- 保存常规信息 -->
            <div class="bbutton">
                <el-button type="primary" style="float:right;" @click="handleMessage">保存</el-button>
            </div>
        </div>
        <div class="Usermanagementborder margin-top1">
            <p>联系信息</p>
            <div class="el-form-item" style="width: 90%;">
                <label class="el-form-item__label" for style="width: 80px;">手机号码</label>
                <div class="el-form-item__content" style="margin-left: 80px;">
                    <el-input v-model="user.phone" placeholder="请输入手机号码"></el-input>
                </div>
            </div>
            <div class="el-form-item" style="width: 90%;">
                <label class="el-form-item__label" for style="width: 80px;">QQ号码</label>
                <div class="el-form-item__content" style="margin-left: 80px;">
                    <el-input v-model="user.qq" placeholder="请输入QQ号码"></el-input>
                </div>
            </div>
            <div class="el-form-item" style="width: 90%;">
                <label class="el-form-item__label" for style="width: 80px;">邮箱</label>
                <div class="el-form-item__content" style="margin-left: 80px;">
                    <el-input v-model="user.mail" placeholder="请输入邮箱"></el-input>
                </div>
            </div>
            <!-- 保存联系信息 -->
            <div class="bbutton">
                <el-button type="primary" style="float:right;" @click="handleUser">保存</el-button>
            </div>
        </div>
        <div class="Usermanagementborder margin-left2 margin-top1">
            <p>修改密码</p>
            <div class="el-form-item" style="width: 90%;">
                <label class="el-form-item__label" for style="width: 80px;">手机号码</label>
                <div class="el-form-item__content" style="margin-left: 80px;" >
                    <el-input v-model="password.phone" placeholder="请输入手机号码" :disabled="true"></el-input>
                </div>
            </div>
            <div class="el-form-item" style="width: 90%;">
                <label class="el-form-item__label" for style="width: 80px;">原始密码</label>
                <div class="el-form-item__content" style="margin-left: 80px;">
                    <el-input v-if="visible" v-model="password.oldPassWord" placeholder="请输入原始密码" type="password">
                        <i slot="suffix" title="显示密码" 
                            class="iconfont icon-yanjingbi"
                            style="cursor:pointer;margin-right:5px"
                            @click="changePass('show')"
                        ></i>
                    </el-input>
                    <el-input v-else v-model="password.oldPassWord" placeholder="请输入原始密码" type="text">
                        <i slot="suffix" title="隐藏密码" 
                            class="iconfont icon-yanjing"
                            style="cursor:pointer;margin-right:5px"
                            @click="changePass('hide')"
                        ></i>
                    </el-input>
                </div>
            </div>
            <div class="el-form-item" style="width: 90%;">
                <label class="el-form-item__label" for style="width: 80px;">新密码</label>
                <div class="el-form-item__content" style="margin-left: 80px;">
                    <el-input v-if="visible1" @blur="verification" v-model="password.newPassWord" placeholder="8位及以上包含数字、大小写字母、特殊符号" type="password">
                        <i slot="suffix" title="显示密码" 
                            class="iconfont icon-yanjingbi"
                            style="cursor:pointer;margin-right:5px"
                            @click="changePass1('show')"
                        ></i>
                    </el-input>
                    <el-input v-else @blur="verification" v-model="password.newPassWord" placeholder="8位及以上包含数字、大小写字母、特殊符号" type="text">
                        <i slot="suffix" title="隐藏密码" 
                            class="iconfont icon-yanjing"
                            style="cursor:pointer;margin-right:5px"
                            @click="changePass1('hide')"
                        ></i>
                    </el-input>
                </div>
            </div>
            <div class="el-form-item" style="width: 90%;">
                <label class="el-form-item__label" for style="width: 80px;">确认密码</label>
                <div class="el-form-item__content" style="margin-left: 80px;">
                    <el-input
                        v-if="visible2"
                        v-model="password.confirmPassWord"
                        placeholder="请输入确认密码"
                        type="password"
                    >
                        <i slot="suffix" title="显示密码" 
                            class="iconfont icon-yanjingbi"
                            style="cursor:pointer;margin-right:5px"
                            @click="changePass2('show')"
                        ></i>
                    </el-input>
                    <el-input
                        v-else
                        v-model="password.confirmPassWord"
                        placeholder="请输入确认密码"
                        type="text"
                    >
                        <i slot="suffix" title="隐藏密码" 
                            class="iconfont icon-yanjing"
                            style="cursor:pointer;margin-right:5px"
                            @click="changePass2('hide')"
                        ></i>
                    </el-input>
                </div>
            </div>
            <!-- 修改密码 -->
            <div class="bbutton">
                <el-button type="primary" style="float:right;" @click="handlePassword">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { ajaxPost, Baseurl, formatDate } from "../../api/api/api.js";
export default {
    name: "Usermanagement",
    data() {
        return {
			visible: true,
			visible1: true,
			visible2: true,
            input: "",
            dialogImageUrl: "",
            number: false,
            dialogVisible: false,
            file: {},
            action: Baseurl + "imageController/uploadImage",
            // 常规信息
            message: {
                name: "",
                radio: "1",
                birthday: "",
                location: ""
            },
            // 联系信息
            user: {
                phone: "",
                qq: "",
                mail: ""
            },
            // 修改密码
            password: {
                phone: "",
                oldPassWord: "",
                newPassWord: "",
                confirmPassWord: ""
            },
            customHeaders: { token: localStorage.getItem("token") }
        };
    },
    mounted() {
        this.getUser();
    },
    created() {},
    methods: {
		changePass(value) {
			this.visible = !(value === 'show')
		},
		changePass1(value) {
			this.visible1 = !(value === 'show')
		},
		changePass2(value) {
			this.visible2 = !(value === 'show')
		},
        verification(val) {
            console.log(val)
            let str = /^(?![A-Za-z]+$)(?![A-Z0-9]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![A-Z\W_!@#$%^&*`~()-+=+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,100}$/
            // console.log(this.password.newPassWord)
            // console.log(val.target)
            if (!str.test(this.password.newPassWord)) {
                val.target.style.borderColor = 'red'
                this.$message.error('新密码格式不正确，请重新输入！')
            } else {
                val.target.style.borderColor = '#DCDFE6'
            }
        },
        // 图片
        handleAvatarSuccess(file) {
            this.dialogImageUrl = file.data;
        },
        // 获取信息
        getUser() {
            var role = JSON.parse(localStorage.getItem("role"));
            ajaxPost(Baseurl + "userControllers/selectUserInfoByUid", {
                uid: role.uid
            }).then(res => {
               res.data.data.gender = res.data.data.gender==null ? "1" : String(res.data.data.gender);
               res.data.data.address = res.data.data.address==null? "" : res.data.data.address;
                // 常规信息
                this.dialogImageUrl = res.data.data.headPortrait;
                this.message.name = res.data.data.userName;
                this.message.radio = res.data.data.gender;
                this.message.birthday = res.data.data.birthday;
                // this.message.bloodType=

                this.message.location = res.data.data.address;
                this.user.phone = res.data.data.telephone;
                this.user.qq = res.data.data.qq;
                this.user.mail = res.data.data.email;

                this.password.phone = res.data.data.telephone;
            });
        },
        // 保存头像
        handleHead() {
            var role = JSON.parse(localStorage.getItem("role"));
            ajaxPost(Baseurl + "userControllers/updateHeadPortrait", {
                uid: role.uid,
                headPortrait: this.dialogImageUrl
            }).then(res => {
                this.$message({
                    message: "保存成功",
                    type: "success"
                });
            });
        },
        // 保存常规信息
        handleMessage() {
            if(this.message.name == ""){
                this.$message.error('请填写姓名！');
            }else{
                var date = new Date(this.message.birthday);
                var role = JSON.parse(localStorage.getItem("role"));
                var message = {
                    uid: role.uid,
                    userName: this.message.name,
                    gender: this.message.radio,
                    birthday:
                        date.getFullYear() +
                        "-" +
                        (date.getMonth() + 1) +
                        "-" +
                        date.getDate(),
                    address: this.message.location
                };
                ajaxPost(
                    Baseurl + "userControllers/updateUserGeneralInfo",
                    message
                ).then(res => {
                    if (res) {
                        this.$message({
                            message: "保存成功",
                            type: "success"
                        });
                        this.message.name = res.data.data.userName;
                        this.message.radio = res.data.data.gender + "";
                        this.message.birthday = res.data.data.birthday;
                        this.message.location = res.data.data.address;
                    }
                });
            }
        },
        // 保存联系信息
        handleUser() {
            if (this.user.phone && this.user.qq && this.user.mail) {
                var role = JSON.parse(localStorage.getItem("role"));
                var user = {
                    uid: role.uid,
                    telephone: this.user.phone,
                    qq: this.user.qq,
                    email: this.user.mail
                };
                ajaxPost(
                    Baseurl + "userControllers/updateUserContactInfo",
                    user
                ).then(res => {
                    if (res) {
                        this.$message({
                            message: "保存成功",
                            type: "success"
                        });
                        (this.user.phone = res.data.data.telephone),
                            (this.user.qq = res.data.data.qq),
                            (this.user.mail = res.data.data.email);
                        this.password.phone = res.data.data.telephone;
                    }
                });
            } else {
                this.$message.error("请检查信息是否完整");
            }
        },
        // 修改密码
        handlePassword() {
            if (
                this.password.phone &&
                this.password.oldPassWord &&
                this.password.newPassWord &&
                this.password.confirmPassWord
            ) {
                let str = /^(?![A-Za-z]+$)(?![A-Z0-9]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![A-Z\W_!@#$%^&*`~()-+=+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/
                // console.log(this.password.newPassWord)
                if (!str.test(this.password.newPassWord)) {
                    this.password.newPassWord = ''
                    this.$message.error('新密码格式不正确，请重新输入！')
                    return
                } else if (
                    this.password.newPassWord == this.password.confirmPassWord
                ) {
                    var password = {
                        telephone: this.password.phone,
                        oldPassword: this.password.oldPassWord,
                        newPassword: this.password.newPassWord,
                        cfgPassword: this.password.confirmPassWord
                    };
                    // console.log(password);
                    ajaxPost(
                        Baseurl + "userControllers/updatePassword",
                        password
                    ).then(res => {
                        if (res) {
                            if(res.data.code !== 200){
                                this.$message.error(res.data.data);
                                return
                            }
                            // this.$alert("密码修改成功，请重新登录！", "密码提示", {
                            //     confirmButtonText: "确定",
                            //     callback: action => {
                            //         // this.$message({
                            //         //     type: "info",
                            //         //     message: `action: ${action}`
                            //         // });
                            //     }
                            // }).then((action) => {
                            //     if(action === 'confirm'){
                            //          this.$router.replace({path:'http://localhost:8080'})
                            //     }
                            // })
                            this.$message({
                                message: "密码修改成功，请重新登录！",
                                type: "success"
                            });
                            this.$store.commit("loginOut");
                            this.$router.push({
                                path: "/login"
                            });
                            // this.$alert("密码修改成功，请重新登录！", "提示", {
                            //     confirmButtonText: "确定",
                            //     type: "warning"
                            // }).then(action => {
                            //     if (action === "confirm") {
                            //         this.$router.push({
                            //             path: "/login"
                            //         });
                            //     }
                            // });
                        }
                    });
                } else {
                    this.$message.error("确认密码与新密码不一致，重新输入");
                }
            } else {
                this.$message.error("请检查要修改的信息是否完整");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.Usermanagement {
    width: 98%;
    .Usermanagementborder {
        border-radius: 5px;
        height: 325px;
        width: 48%;
        float: left;
        border: 1px #eee solid;
        overflow: hidden;
    }
    .left {
        overflow: hidden;
        float: left;
        width: 50%;
    }
    .width40 {
        width: 75%;
    }
    p {
        margin-bottom: 20px;
        padding-left: 8px;
        background: #eee;
        font-size: 16px;
        line-height: 40px;
        color: #828080;
    }
    .el-form-item {
        margin-bottom: 15px;
        .el-form-item__label {
            text-align: right;
            float: left;
            font-size: 14px;
            color: #606266;
            line-height: 40px;
            padding: 0 12px 0 0;
            box-sizing: border-box;
        }
        .el-form-item__content {
            line-height: 40px;
            position: relative;
            font-size: 14px;
        }
    }
    .bbutton {
        float: left;
        width: 90%;
        margin-bottom: 20px;
    }
}
</style>
